export default {
    validationClass: {
        get: function(dirty, valid) {
            return !dirty ? '' : valid ? 'is-valid' : 'is-invalid';
        },
        set: function() {}
    }
}